import './OrderView.css';

import { IonBadge, IonCard, IonCardContent, IonCol, IonContent, IonItem, IonLabel, IonPage, IonRow, IonText } from '@ionic/react';
import { arrowRedoOutline, cardOutline, closeOutline, cubeOutline, mailOutline, sendOutline } from 'ionicons/icons';

import DetailItem from './DetailItem';
import LayoutGap from '../../../../layouts/LayoutGap';
import Toolbar from '../../../../layouts/Toolbar';
import HR from '../../../../layouts/HR';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { OrderDetailGetAction } from '../../../../redux/actions/Account';
import { RouteComponentProps } from 'react-router';
import LoadingContainer from '../../../../components/loading/LoadingContainer';

interface Props extends RouteComponentProps<{
    order_id: string
}> { }

const OrderView: React.FC<Props> = ({ match }) => {
    const dispatch = useAppDispatch()

    const orderSingle = useAppSelector(state => state.orderDetailReducer)
    const { loading, orderDetail } = orderSingle

    const [statusList, setStatusList] = useState({
        PAID: { passed: false, active: false },
        CONFIRMED: { passed: false, active: false },
        PREPARING: { passed: false, active: false },
        SENT: { passed: false, active: false },
        CANCELED: { passed: false, active: false },
        RETURNED: { passed: false, active: false }
    });

    useEffect(() => {
        dispatch(OrderDetailGetAction(match.params.order_id))
    }, [dispatch])

    useEffect(() => {
        if (orderDetail != null && !loading) {
            const statusData = { ...statusList as any }

            for (let i = 0; i < Object.entries(statusData).length; i++) {
                const key = Object.keys(statusData)[i];

                if (key == orderDetail.order?.status) {
                    statusData[key].passed = true;
                    statusData[key].active = true;
                    break;
                } else {
                    statusData[key].passed = true;
                }
            }

            setStatusList(statusData);
        }
    }, [loading])

    return <LoadingContainer loading={loading}>
        <IonPage>
            <Toolbar title="جزئیات سفارش" subTitle={match.params.order_id} hasBackButton />

            <LayoutGap />

            <IonContent className="order-view main-content">
                <IonCard className="card">
                    <IonCardContent className="specs">
                        <IonRow>
                            <IonCol>
                                <div className="ion-margin-bottom">
                                    <IonText><strong>مشخصات گیرنده</strong></IonText>
                                </div>

                                <IonItem lines="none">
                                    <IonLabel color="medium">نام مشتری </IonLabel>
                                    <IonText>{orderDetail.address?.full_name}</IonText>
                                </IonItem>
                                <IonItem lines="none">
                                    <IonLabel color="medium">استان / شهر</IonLabel>
                                    <IonText>{orderDetail.address?.state} / {orderDetail.address?.city}</IonText>
                                </IonItem>
                                <IonItem lines="none">
                                    <IonLabel color="medium">آدرس</IonLabel>
                                    <IonText>{orderDetail.address?.address}</IonText>
                                </IonItem>
                                {orderDetail.address?.mobile.length > 0 ?
                                    <IonItem lines="none">
                                        <IonLabel color="medium">کد پستی</IonLabel>
                                        <IonText>{orderDetail.address?.postal_code}</IonText>
                                    </IonItem> : null}
                                {orderDetail.address?.mobile.length > 0 ?
                                    <IonItem lines="none">
                                        <IonLabel color="medium">تلفن همراه</IonLabel>
                                        <IonText>{orderDetail.address?.mobile}</IonText>
                                    </IonItem> : null}
                                {orderDetail.address?.mobile.length > 0 ?
                                    <IonItem lines="none">
                                        <IonLabel color="medium">تلفن ثابت</IonLabel>
                                        <IonText><div className="d-inline-block ltr">{orderDetail.address?.telephone}</div></IonText>
                                    </IonItem> : null}
                            </IonCol>
                        </IonRow>
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <div className="ion-margin-bottom">
                            <IonText><strong>وضعیت سفارش</strong></IonText>
                        </div>

                        <DetailItem icon={cardOutline} title="پرداخت شده" passed={statusList.PAID.passed} active={statusList.PAID.active} />

                        <DetailItem icon={cubeOutline} title="آماده سازی سفارش" passed={statusList.PREPARING.passed} active={statusList.PREPARING.active} />

                        <DetailItem icon={mailOutline} title={`تحویل به پست <a target="_blank" href="${orderDetail.order?.tracking}">(رهگیری)</a>`} subtitle={`بارکد مرسوله: ${orderDetail.order?.barcode}`} passed={statusList.CONFIRMED.passed} active={statusList.CONFIRMED.active} />

                        <DetailItem icon={sendOutline} title="ارسال شده" passed={statusList.SENT.passed} active={statusList.SENT.active} />

                        <DetailItem icon={closeOutline} title="لغو شده" passed={statusList.CANCELED.passed} active={statusList.CANCELED.active} />

                        <DetailItem icon={arrowRedoOutline} title="مرجوع شده" passed={statusList.RETURNED.passed} active={statusList.RETURNED.active} />
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <div className="ion-margin-bottom">
                            <IonText><strong>محصولات</strong></IonText>
                        </div>
                        {
                            orderDetail.products?.map((item: any) => {
                                return <>
                                    <IonRow className="order-product">
                                        <IonCol size="8">
                                            <IonText><strong>{item.name}</strong></IonText>
                                            <IonText>{item.color} <IonBadge color="danger">{item.quantity} عدد</IonBadge></IonText>
                                        </IonCol>
                                        <IonCol size="4" className="ion-text-left">
                                            <IonText><strong>{Number(item.price).toPrice()}</strong></IonText>
                                        </IonCol>
                                    </IonRow>
                                    <HR />
                                </>
                            })
                        }

                        <IonRow className="ion-margin-top">
                            <IonCol size="6" className="ion-text-right">
                                <IonText>هزینه ارسال</IonText>
                            </IonCol>
                            <IonCol size="6" className="ion-text-left">
                                <IonText><strong>{Number(orderDetail.order?.delivery).toPrice()}</strong></IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow className="ion-margin-top">
                            <IonCol size="6" className="ion-text-right">
                                <IonText>هزینه بسته بندی</IonText>
                            </IonCol>
                            <IonCol size="6" className="ion-text-left">
                                <IonText><strong>{Number(orderDetail.order?.packing).toPrice()}</strong></IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow className="ion-margin-top">
                            <IonCol size="6" className="ion-text-right">
                                <IonText>مبلغ کل محصولات</IonText>
                            </IonCol>
                            <IonCol size="6" className="ion-text-left">
                                <IonText><strong>{Number(orderDetail.order?.products_price).toPrice()}</strong></IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow className="ion-margin-top">
                            <IonCol size="6" className="ion-text-right">
                                <IonText>تخفیف</IonText>
                            </IonCol>
                            <IonCol size="6" className="ion-text-left">
                                <IonText><strong>{Number(orderDetail.order?.discount).toPrice()}</strong></IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow className="ion-margin-top">
                            <IonCol size="6" className="ion-text-right">
                                <IonText>مبلغ کل سفارش</IonText>
                            </IonCol>
                            <IonCol size="6" className="ion-text-left total-price">
                                <IonText className=""><strong>{Number(orderDetail.order?.total_price).toPrice()}</strong></IonText>
                            </IonCol>
                        </IonRow>
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    </LoadingContainer>
}

export default OrderView;